import { SOCIAL_MEDIA_TYPES } from '../../../../../constants';

export const CUSTOM_LINK_LIMIT = 2;

export const SOCIAL_CONFIGS = {
  [SOCIAL_MEDIA_TYPES.FACEBOOK]: {
    LABEL: 'Facebook',
    START_ICON: 'facebook',
  },
  [SOCIAL_MEDIA_TYPES.INSTAGRAM]: {
    LABEL: 'Instagram',
    START_ICON: 'instagram',
  },
  [SOCIAL_MEDIA_TYPES.X]: {
    LABEL: 'X.com (Twitter)',
    START_ICON: 'x-com',
  },
  [SOCIAL_MEDIA_TYPES.YELP]: {
    LABEL: 'Yelp',
    START_ICON: 'yelp',
  },
};
